export const PATH = {
  HOME: "/procedure/export-warehouse",
};
